import React, { useState, useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom'
import BookingConfirmed from '../BookingConfirmed/BookingConfirmed';
import CabDetails from '../CabDetails/CabDetails';
import BookingDetails from '../BookingDetails/BookingDetails';
import InfoListCard from '../InfoListCard/InfoListCard';
import ManageTripCard from '../ManageTripCard/ManageTripCard';
import LoadingScreen from '../../../HobListing/gi-components/LoadingScreen/LoadingScreen';
import PopUp from '../../../HobListing/gi-components/PopUp/Popup'
import * as S from './HobThankYouStyles';
import { API_STATUS, CONSTANTS, GOIBIBO, GOIBIBO_ICON_URL, HOB_PLACEHOLDER } from '../../../../../config/constants';
import PolicyPage from '../PolicyPage/PolicyPage';
import { getHOBThankYouData } from '../../../redux/thunks';
import { useDispatch, useStore } from 'react-redux';
import { returnIds, Strings, kioskImage, formatDateTime } from '../../../utils';
import { UPDATE_HOB_THANKYOU_RESPONSE } from '../../../redux/action-types';
import { gcHobThankyouScreen, pageViewOmniEvent, pushCtaOmniEvents, sendEventOnError } from '../../../../../config/omni';
import { CABS_HOB_THANK_YOU_ROUTE, DYNAMIC_ERROR, HOB_THANK_YOU_PAGE, MOB_CABS_HOB_THANK_YOU, MY_TRIPS_CTA_CLICKED, POLICIES_CLICKED } from '../../../../../utils/util-constants';
import { CTA_TYPE } from '../../../../../utils/omni-utils';

const HobThankYou = () => {
  const [thankYouApiStatus, setThankYouApiStatus] = useState(API_STATUS.INITIAL);
  const [thankYouResponse, setThankYouResponse] = useState(null);
  const [showImpInfoBottomSheet, setImpInfoBottomSheet] = useState(false)
  const [popUpMessage, setPopUpMessage] = useState('');
  const { refId, bookingId } = returnIds()
  const history = useHistory()
  const store = useStore()

  const dispatch = useDispatch()

  const handleBackPress = () => {
    history.back();
  }
  
  useEffect(() => {
    async function fetchAndSetThankYouData(request) {
      try {
        setThankYouApiStatus(API_STATUS.LOADING);
        const thankYouResponse = await getHOBThankYouData(request);
        setThankYouResponse(thankYouResponse || null);
        validateThankYouResponse(thankYouResponse);
        setThankYouApiStatus(API_STATUS.SUCCESS);
      } catch (e) {
        setThankYouApiStatus(API_STATUS.INITIAL);
      }
    }
  
    const request = {
      bookingId,
      refId,
      type: CONSTANTS.thankYouRequest,
      book_mode: CONSTANTS.bookMode
    };
    fetchAndSetThankYouData(request); 
  }, [bookingId, refId]);

  const validateThankYouResponse = (thankYouResponse) => {
    dispatch({
      type: UPDATE_HOB_THANKYOU_RESPONSE,
      data: thankYouResponse?.response
    })
    if (Boolean(thankYouResponse?.errors?.error_list?.length)) {
      pushCtaOmniEvents(`${MOB_CABS_HOB_THANK_YOU}_${DYNAMIC_ERROR}_${thankYouResponse?.errors?.error_list[0]?.code || ''}`, CTA_TYPE.HYPER_LINK, HOB_THANK_YOU_PAGE, CABS_HOB_THANK_YOU_ROUTE)
      sendEventOnError([{
        field: `hob_thankyou_load_error_${thankYouResponse?.errors?.error_list[0]?.code || ''}`,
        message: `${thankYouResponse?.errors?.error_list[0]?.message ?? ''}`
      }])
      setThankYouApiStatus(API_STATUS.INITIAL);
      setPopUpMessage(thankYouResponse?.errors?.error_list[0]?.message || thankYouResponse?.errors?.error_list[0]?.code)
      return;
    }
    pageViewOmniEvent(store.getState(), gcHobThankyouScreen)
  }

  const KioskData = useMemo(() => {
    return {
      otpTxt: {
        label1: Strings.label1,
        value: `${thankYouResponse?.response?.supplierDetails?.otp || ''}`,
        label2: Strings.label2
      },
      ownerDetails: {
        label: `${thankYouResponse?.response?.supplierDetails?.supplierName || ''}`,
        subLabel: `${thankYouResponse?.response?.supplierDetails?.cabModel || ''}`,
        ratingVal: `${thankYouResponse?.response?.supplierDetails?.rating || ''}`
      },
      vehicleImg: `${thankYouResponse?.response?.supplierDetails?.cabImage || ''}`,
      facilities: thankYouResponse?.response?.supplierDetails?.utilities?.map((utility, index) => ({
        img: HOB_PLACEHOLDER,
        label: `${utility?.text}`
      })),
      guideSectionData: {
        label: `${thankYouResponse?.response?.kioskDetails?.stepsToReachHeading || ''}`,
        subLabel: thankYouResponse?.response?.kioskDetails?.steps,
        listItems: kioskImage(thankYouResponse?.response?.kioskDetails)
      },
      footerData: {
        source: {
          label: `${thankYouResponse?.response?.tripDetails?.pickupAddress?.mainText || ''}`,
          subLabel: `${thankYouResponse?.response?.tripDetails?.pickupAddress?.secondaryText || ''}`,
          dateTime: `${formatDateTime(thankYouResponse?.response?.tripDetails?.startTime) || ''}`
        },
        destination: {
          label: `${thankYouResponse?.response?.tripDetails?.dropAddress?.mainText || ''}`,
          subLabel: `${thankYouResponse?.response?.tripDetails?.dropAddress?.secondaryText || ''}`,
        }
      },
      kioskMapUrl: thankYouResponse?.response?.kioskDetails?.kioskLocationUrl
    };
  }, [thankYouResponse]);

  const cabData = useMemo(() => {
    return {
      headerSection: {
        ownerDetails: {
          label: `${thankYouResponse?.response?.supplierDetails?.supplierName || ''}`,
          subLabel: `${thankYouResponse?.response?.supplierDetails?.cabModel || ''}`,
          ratingVal: `${thankYouResponse?.response?.supplierDetails?.rating || ''}`
        },
        listItems: thankYouResponse?.response?.supplierDetails?.utilities.map(item => item?.text)
      },
      footerData: {
        source: {
          label: `${thankYouResponse?.response?.tripDetails?.pickupAddress?.mainText || ''}`,
          subLabel: `${thankYouResponse?.response?.tripDetails?.pickupAddress?.secondaryText || ''}`,
          dateTime: `${formatDateTime(thankYouResponse?.response?.tripDetails?.startTime) || ''}`
        },
        destination: {
          label: `${thankYouResponse?.response?.tripDetails?.dropAddress?.mainText || ''}`,
          subLabel: `${thankYouResponse?.response?.tripDetails?.dropAddress?.secondaryText || ''}`,
        }
      }
    };
  }, [thankYouResponse]);

  const myTripsNavigation = (url) => {
    pushCtaOmniEvents(`${MOB_CABS_HOB_THANK_YOU}_${MY_TRIPS_CTA_CLICKED}`, CTA_TYPE.BUTTON, HOB_THANK_YOU_PAGE, url)

    if (Boolean(url) && typeof window !== "undefined") {
      window.location.replace(url);
    }
  }

  if (thankYouApiStatus === API_STATUS.LOADING) {
    return (<LoadingScreen />);
  }

  if (Boolean(popUpMessage)) {
    return (
      <PopUp
        onCrossClick={() => {
          setPopUpMessage('');
          handleBackPress();
        }}
        shouldShow={Boolean(popUpMessage)}
        popUpMessage={popUpMessage}
      />
    );
  }

  const isKiosk = thankYouResponse?.response?.kioskType === CONSTANTS.KIOSK
  return (
    <>
      <S.BrandListingHeader>
        <S.HeaderContainer>
          <S.BrandMmtLogo src={GOIBIBO_ICON_URL}/>
          <S.BrandMmtHeaderTitle>{GOIBIBO}</S.BrandMmtHeaderTitle>
        </S.HeaderContainer>
      </S.BrandListingHeader>
      {thankYouApiStatus === API_STATUS.SUCCESS && thankYouResponse?.status === CONSTANTS.SUCCESS && (
        <S.PostSalesContainer>
          <S.IncExcContainer className={thankYouResponse?.response?.incExcData ? '' : 'height80'}>
            {isKiosk ? (
              <BookingConfirmed heading={`${thankYouResponse?.response?.tripDetails?.bookingStatus}`} footerTxt={thankYouResponse?.response?.tripDetails?.bookingId}>
                <BookingDetails data={KioskData} rightImg={thankYouResponse?.response?.supplierDetails?.supplierImage} />
              </BookingConfirmed>
            ) : (
              <BookingConfirmed heading={`${thankYouResponse?.response?.tripDetails?.bookingStatus}`} footerTxt={thankYouResponse?.response?.tripDetails?.bookingId}>
                <CabDetails data={cabData} isPreDeparture={thankYouResponse?.response?.source === CONSTANTS.departure} refId={refId} bookingId={bookingId} rightImg={thankYouResponse?.response?.supplierDetails?.supplierImage} cityToAirport={thankYouResponse?.response?.cityToAirport} />
              </BookingConfirmed>
            )}
            {thankYouResponse?.response?.incExcData &&
              <InfoListCard
                title={thankYouResponse?.response?.incExcData?.title}
                ctaText={thankYouResponse?.response?.incExcData?.footer_text?.text}
                ctaClickHandler={() => {
                  setImpInfoBottomSheet(true);
                  pushCtaOmniEvents(`${MOB_CABS_HOB_THANK_YOU}_${POLICIES_CLICKED}`, CTA_TYPE.BUTTON, HOB_THANK_YOU_PAGE, CABS_HOB_THANK_YOU_ROUTE)
                }}
                data={thankYouResponse?.response?.incExcData?.brief_details}
              />
            }
          </S.IncExcContainer>
          {thankYouResponse?.response?.myTripsUrl &&
            <ManageTripCard
              label='Manage Your Trip & Get All The Help'
              btnTxt='Go To My Trips'
              btnClickHandler={() => { myTripsNavigation(thankYouResponse?.response?.myTripsUrl) }}
            />
          }
          {showImpInfoBottomSheet && thankYouResponse?.response?.incExcData && (
            <PolicyPage
              policyDetails={thankYouResponse?.response?.data?.length ? thankYouResponse?.response?.data[0] : []}
              closeModal={() => setImpInfoBottomSheet(false)}
            />
          )}
        </S.PostSalesContainer>
      )}
    </>
  );
}

export default HobThankYou;
